/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyPosition,
    JsonCompanyPositionFromJSON,
    JsonCompanyPositionFromJSONTyped,
    JsonCompanyPositionToJSON,
} from './JsonCompanyPosition';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyPosition
 */
export interface ApiResultOfJsonCompanyPosition {
    /**
     * 
     * @type {JsonCompanyPosition}
     * @memberof ApiResultOfJsonCompanyPosition
     */
    data?: JsonCompanyPosition;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyPosition
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyPosition
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyPosition
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyPosition
     */
    result?: ApiResultOfJsonCompanyPositionResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyPositionResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyPositionFromJSON(json: any): ApiResultOfJsonCompanyPosition {
    return ApiResultOfJsonCompanyPositionFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyPosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyPositionFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyPositionToJSON(value?: ApiResultOfJsonCompanyPosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyPositionToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

